export default function pageDirective($timeout, DataService) {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		transclude: true,
		templateUrl: "./components/page/page-template.html",
		scope: {
			id: "<",
			type: "@",
			heading: "@",
			background: "@",
			loading: "<",
			errored: "<",
			noBreadcrumbs: "<",
			noSearch: "<",
			onTypeClick: "&?"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function ($scope) {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
				vm.headerTypeClickable = !!vm.onTypeClick;

				$scope.$watch(() => (vm.id), vm.update);
				$scope.$watch(() => (vm.loading), vm.startWait);
			};

			vm.update = () => {
				if (!vm.noBreadcrumbs) {
					DataService.getOrgParents(vm.id, vm.type).then((parents) => {
						vm.parents = parents.reverse();
					});
				}
			};

			vm.startWait = () => {
				vm.waiting = false;
				$timeout.cancel(vm.waitTimer);
				if (vm.loading) {
					// wait a few seconds then show prolonged waiting message
					vm.waitTimer = $timeout(() => {
						vm.waiting = true;
					}, 8 * 1000);
				}
			};
		}
	};
}
